import ErrorBoundary, {ErrorBoundaryProps} from "./ErrorBoundary.tsx";


class RouteErrorBoundary extends ErrorBoundary {
    private prevPath :string = '';

    constructor(props: ErrorBoundaryProps) {
        super(props);
    }
    componentDidMount() {
        this.prevPath = window.location.pathname;
    }
    componentDidUpdate() {
        if (window.location.pathname !== this.prevPath) {
            this.setState({hasError: false});
        }
        this.prevPath = window.location.pathname;
    }
}

export default RouteErrorBoundary;
